import { render, staticRenderFns } from "./commonEmpty.vue?vue&type=template&id=66d6e591&scoped=true&"
import script from "./commonEmpty.vue?vue&type=script&lang=js&"
export * from "./commonEmpty.vue?vue&type=script&lang=js&"
import style0 from "./commonEmpty.vue?vue&type=style&index=0&id=66d6e591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d6e591",
  null
  
)

export default component.exports